import { Link } from '../Membership/membership-form-template/contracts';
import { MenuProps } from '../MegaMenu/contracts';

export const HEADER_LINKS_ID = 'burger-menu-links';
export const NAV_SEPARATOR = '+/+';

export type ButtonInputModel = {
	buttonText: string;
	buttonLink: Link;
	variant?: 'primary' | 'secondary' | 'tertiary';
};

export type LoginStatusButtonInputModel = {
	loginRedirectUrl: Link;
	logoutRedirectUrl: Link;
	variant?: 'primary' | 'secondary' | 'tertiary';
};

export type HambugerMenuProps = MenuProps & {
	headerButtons: ButtonInputModel[];
	loginStatus: LoginStatusButtonInputModel[];
};
